/**
 * メッセージング関連のハンドラー関数群
 */

/**
 * メッセージング関連の状態管理ユーティリティ
 * @param {Function} setMessagingPartner - メッセージングパートナーのsetter
 * @param {Function} setIsMessaging - メッセージング状態のsetter
 * @returns {Object} メッセージング操作関数群
 */
export const createMessagingHandlers = (setMessagingPartner, setIsMessaging) => {
  const handleOpenMessaging = (partner) => {
    setMessagingPartner(partner);
    setIsMessaging(true);
  };

  const handleCloseMessaging = () => {
    setIsMessaging(false);
    setMessagingPartner(null);
  };

  return {
    handleOpenMessaging,
    handleCloseMessaging
  };
};

/**
 * ノートモーダル関連のハンドラー関数群
 * @param {Function} setIsNotesModalOpen - ノートモーダル状態のsetter
 * @returns {Object} ノートモーダル操作関数群
 */
export const createNotesModalHandlers = (setIsNotesModalOpen) => {
  const handleOpenNotesModal = () => {
    setIsNotesModalOpen(true);
  };

  const handleCloseNotesModal = () => {
    setIsNotesModalOpen(false);
  };

  return {
    handleOpenNotesModal,
    handleCloseNotesModal
  };
}; 